import React, { Component } from 'react';
import Snake from './Snake';
import './App.css';

class App extends Component {
  render() {
    return (
      <div className="App">
        <Snake />
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js